import { render } from "./profile-logout.svg?vue&type=template&id=5d6d0fa8"
const script = {}
script.render = render

export default script